module.exports = __webpack_public_path__ + "img/enging_room_pic03.34d6b065.png";